// src/components/LogoutButton.js
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@chakra-ui/react';
import { auth0Config } from '../config/auth.config';

/**
 * Logout button that clears Auth0 session
 * Uses centralized config for redirect URI
 * federated: true ensures logout from identity provider too
 */
const LogoutButton = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: auth0Config.logoutRedirectUri,
      },
      federated: true,
    });
  };

  return (
    <Button colorScheme="teal" onClick={handleLogout}>
      Log Out
    </Button>
  );
};

export default LogoutButton;
